module.exports = __webpack_public_path__ + "img/support.2b5f0693.jpg";